import React, { useCallback, useState } from 'react'
import { Form, Formik } from 'formik'
import Dropdown, { OptionType } from 'components/Dropdown'
import Input from 'components/Input'
import { useBatchLookupTx } from './useBatchLookupTx'
import { BatchLookupTxSchemas } from 'schemas/bulkTransactionsTxSchemas'
import { BatchLookupTxSetFieldTypes } from 'types/bulkTransactionsTXTypes'

const Index: React.FC<{
  setFieldValue: BatchLookupTxSetFieldTypes
  title?: string
  placeholder?: string
}> = ({ setFieldValue: setFieldValueMain, title, placeholder }) => {
  const [selectedBatchLabel, setSelectedBatchLabel] = useState('')
  const [selectedBatchId, setSelectedBatchId] = useState('')

  const {
    initialValues,
    handleSubmitBatchLookupTx,
    batchLookupDropdownOptions,
  } = useBatchLookupTx(setFieldValueMain)

  const loadOptions = useCallback(
    (inputValue: string) => batchLookupDropdownOptions(inputValue),
    [batchLookupDropdownOptions]
  )

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={BatchLookupTxSchemas}
      onSubmit={handleSubmitBatchLookupTx}
    >
      {() => (
        <Form className="flex flex-col">
          <div className="mb-0">
            <Dropdown
              title={title || 'Batch Lookup'}
              value={selectedBatchLabel}
              placeholder={placeholder || "Search by batch id..."}
              loadOptions={loadOptions}
              onChange={(option: OptionType) => {
                const batchId = option?.value
                const batchLabel = option?.label
                setFieldValueMain('batchId', batchId)  // This sets the batchId in the parent form
                setSelectedBatchId(String(batchId))
                setSelectedBatchLabel(batchLabel)
              }}
              className="w-full"
              borderColor="#C4C4C4"
              containerClassName="focus:border-primary"
              isSearchable
              async
            />
          </div>
          <Input
            type="hidden"
            name="batchId"
            value={selectedBatchId}
            className='mb-0'
          />
        </Form>
      )}
    </Formik>
  )
}

export default Index
